import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { useLinkLikeClick, usePageBrowserTabTitle } from '../../../../hooks'
import { Page } from '../../../Page'
import { PageHeader } from '../../../PageHeader'

import { QA_NAME_INTEGRATIONS_IMPORT_LOG } from './IntegrationsImportLog.constants'
import {
  useIntegrationsImportRuns,
  useIntegrationsReprocess,
} from './IntegrationsImportLog.hooks'
import {
  getImportLogBreadcrumbs,
  getImportRunLink,
  getIsImportRunActionReprocess,
  getIsImportRunsEmpty,
} from './IntegrationsImportLog.utils'
import { IntegrationsImportLogEmpty } from './IntegrationsImportLogEmpty'
import { IntegrationsImportLogFilters } from './IntegrationsImportLogFilters'
import { IntegrationsImportLogLoadError } from './IntegrationsImportLogLoadError'
import { IntegrationsImportLogRuns } from './IntegrationsImportLogRuns'
import { IntegrationsReprocessModal } from './IntegrationsReprocessModal'

import * as styles from './IntegrationsImportLog.module.css'

// TODO: the whole screen rides the fixture until the import run endpoints exist
function IntegrationsImportLog() {
  const { t } = useTranslation()

  const { handleClick, handleMouseDown } = useLinkLikeClick()

  const containerRef = useRef(null)

  const {
    handleRetry,
    handleSelectSource,
    handleSelectStatus,
    handleSetPagination,
    hasError,
    isInitiated,
    isLoading,
    items,
    pagination,
    source,
    status,
  } = useIntegrationsImportRuns()

  const {
    handleCancelReprocess,
    handleConfirmReprocess,
    handleStartReprocess,
    reprocessedRun,
  } = useIntegrationsReprocess({ onReprocessed: handleRetry })

  const title = t('RentalPortal.IntegrationsImportLogTitleKey')

  usePageBrowserTabTitle({ isLoading: isLoading, pageTitle: title })

  function handleClickRun(runId, event) {
    handleClick({ event, link: getImportRunLink(runId) })
  }

  function handleMouseDownRun(runId, event) {
    handleMouseDown({ event, link: getImportRunLink(runId) })
  }

  function handleCallRunAction(action, item) {
    return getIsImportRunActionReprocess(action)
      ? handleStartReprocess(item)
      : null
  }

  return (
    <Page
      qaName={QA_NAME_INTEGRATIONS_IMPORT_LOG}
      scrollWrapperRef={containerRef}
    >
      <PageHeader
        breadcrumbs={getImportLogBreadcrumbs({ t, title })}
        isLoading={isLoading}
        title={title}
      />
      <div className={styles.body}>
        {hasError ? (
          <IntegrationsImportLogLoadError onRetry={handleRetry} />
        ) : null}
        <IntegrationsImportLogFilters
          source={source}
          status={status}
          onSelectSource={handleSelectSource}
          onSelectStatus={handleSelectStatus}
        />
        {getIsImportRunsEmpty({ hasError, isInitiated, isLoading, items }) ? (
          <IntegrationsImportLogEmpty />
        ) : (
          <IntegrationsImportLogRuns
            containerRef={containerRef}
            isInitiated={isInitiated}
            isLoading={isLoading}
            items={items}
            pagination={pagination}
            onCallAction={handleCallRunAction}
            onClickRun={handleClickRun}
            onMouseDownRun={handleMouseDownRun}
            onSetPagination={handleSetPagination}
          />
        )}
      </div>
      {reprocessedRun ? (
        <IntegrationsReprocessModal
          run={reprocessedRun}
          onCancel={handleCancelReprocess}
          onSubmit={handleConfirmReprocess}
        />
      ) : null}
    </Page>
  )
}

export default IntegrationsImportLog
